import { cloneDeep } from 'lodash';

const state = {
  list: [],
  designgroup: {},
  edit_designgroup: {},
  designgroup_category: {},
  edit_designgroup_category: {}
};

const getters = {
  list: (state) => {
    return (state.list || []).map((x) => Object.assign(x, { popularity: x.popularity || {} }));
  },
  designgroup: (state) => {
    return state.designgroup || {};
  },
  edit_designgroup: (state) => {
    return state.edit_designgroup || {};
  },
  designgroup_category: (state) => {
    return state.designgroup_category || {};
  },
  edit_designgroup_category: (state) => {
    return state.edit_designgroup_category || {};
  }
};

const mutations = {
  SET_LIST(state, categories) {
    state.list = categories;
  },
  SET_DESIGNGROUP(state, item) {
    const designgroup = cloneDeep(item);
    if (!designgroup.popularity) {
      designgroup.popularity = { id: null };
    }
    state.designgroup = designgroup;
    state.edit_designgroup = designgroup;
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      const existing = cloneDeep(state.list[index]);
      this._vm.$set(
        state.list,
        index,
        Object.assign(existing, designgroup, {
          publishedCount: existing.publishedCount,
          notPublishedCount: existing.notPublishedCount
        })
      );
    } else {
      state.list.push(designgroup);
    }
  },
  EDIT_DESIGNGROUP(state, item) {
    state.edit_designgroup = cloneDeep(item);
  },
  DELETE_DESIGNGROUP(state, id) {
    state.designgroup = {};
    state.edit_designgroup = {};
    const index = state.list.findIndex((x) => x.id === id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },
  SET_DESIGNGROUP_CATEGORY(state, item) {
    state.designgroup_category = cloneDeep(item);
    state.edit_designgroup_category = cloneDeep(item);
  },
  EDIT_DESIGNGROUP_CATEGORY(state, item) {
    state.edit_designgroup_category = cloneDeep(item);
  },
  SET_NOTES(state, item) {
    if (state.designgroup.id === item.referenceId) {
      this._vm.$set(state.designgroup, 'designNotes', item.notes);
      this._vm.$set(state.edit_designgroup, 'designNotes', item.notes);
    }
    const index = state.list.findIndex((x) => x.id === item.referenceId);
    if (index >= 0) {
      this._vm.$set(state.list[index], 'designNotes', item.notes);
    }
  }
};

const actions = {
  load({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('designgroups/getAll', filter)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  edit({ commit }, designgroup) {
    commit('EDIT_DESIGNGROUP', designgroup);
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`designgroups/get?id=${id}`)
        .then((response) => {
          commit('SET_DESIGNGROUP', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  create({ commit }, designgroup) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('designgroups/create', designgroup)
        .then((response) => {
          commit('SET_DESIGNGROUP', response.data);
          commit('lookup/ADD_DESIGN_GROUP', response.data, { root: true });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update({ commit }, designgroup) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('designgroups/update', designgroup)
        .then((response) => {
          commit('SET_DESIGNGROUP', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`designgroups/delete?designgroupId=${id}`)
        .then(() => {
          commit('DELETE_DESIGNGROUP', id);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCategory({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(
          `designgroups/getCategory?designGroupId=${req.designGroupId}&categoryId=${req.categoryId}`
        )
        .then((response) => {
          commit('SET_DESIGNGROUP_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  editCategory({ commit }, category) {
    commit('EDIT_DESIGNGROUP_CATEGORY', category);
  },
  updateCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('designgroups/updateCategory', category)
        .then((response) => {
          commit('SET_DESIGNGROUP_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateCategories({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`designgroups/updateCategories?designGroupId=${req.designGroupId}`, req.categoryIds)
        .then((response) => {
          commit('SET_DESIGNGROUP', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  savePopularity({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`designgroups/savePopularity?id=${req.id}&popularityId=${req.popularityId}`)
        .then((response) => {
          commit('SET_DESIGNGROUP', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addCatalogContentPage({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `designgroups/addCatalogContentPage?designGroupId=${req.designGroupId}&categoryId=${req.categoryId}`
        )
        .then((response) => {
          commit('SET_DESIGNGROUP_CATEGORY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
